import { createCommand } from 'lexical';
import {
  $applyColor,
  $removeColor,
  $applyHighlight,
  $removeHighlight,
  $applyFontFamily,
  $removeFontFamily,
  $applyFontSize,
  $removeFontSize,
} from './StyledTextHelpers';

// Commands for external use
export const COLOR_COMMAND = createCommand('COLOR_COMMAND');
export const HIGHLIGHT_COMMAND = createCommand('HIGHLIGHT_COMMAND');
export const FONT_FAMILY_COMMAND = createCommand('FONT_FAMILY_COMMAND');
export const FONT_SIZE_COMMAND = createCommand('FONT_SIZE_COMMAND');

/**
 * Command handlers
 */
export function handleColorCommand(color) {
  if (!color) {
    return $removeColor();
  }
  return $applyColor(color);
}

export function handleHighlightCommand(color) {
  if (!color) {
    return $removeHighlight();
  }
  return $applyHighlight(color);
}

export function handleFontFamilyCommand(fontFamily) {
  if (!fontFamily) {
    return $removeFontFamily();
  }
  return $applyFontFamily(fontFamily);
}

export function handleFontSizeCommand(fontSize) {
  if (!fontSize) {
    return $removeFontSize();
  }
  return $applyFontSize(fontSize);
}

/**
 * Register all command handlers for an editor
 */
export function registerStyledTextCommands(editor) {
  const removeListeners = [];

  removeListeners.push(
    editor.registerCommand(
      COLOR_COMMAND,
      (payload) => {
        handleColorCommand(payload);
        return true;
      },
      1 // COMMAND_PRIORITY_LOW
    )
  );

  removeListeners.push(
    editor.registerCommand(
      HIGHLIGHT_COMMAND,
      (payload) => {
        handleHighlightCommand(payload);
        return true;
      },
      1
    )
  );

  removeListeners.push(
    editor.registerCommand(
      FONT_FAMILY_COMMAND,
      (payload) => {
        handleFontFamilyCommand(payload);
        return true;
      },
      1
    )
  );

  removeListeners.push(
    editor.registerCommand(
      FONT_SIZE_COMMAND,
      (payload) => {
        handleFontSizeCommand(payload);
        return true;
      },
      1
    )
  );

  // Return cleanup function
  return () => {
    removeListeners.forEach((remove) => remove());
  };
}
